/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
import {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {useDispatch, useSelector} from 'react-redux';
import DotsLoading from '../../../../../components/dotsLoading';
import CustomSearchBox from '../../../../../components/mazraeKit/customSearchBox';
import NoData from '../../../../../components/noData';
import {RootState} from '../../../../../store/redux';
import {
  addingAdminImages,
  clearAdminImages,
} from '../../../../../store/redux/addPictureAdvertisment';
import {addRegisterAdvertisement} from '../../../../../store/redux/advertisementRegisteration';
import {getQuantityPackUnitByValue} from '../../../../../utilities/helper/unitGenerator/unit.types';
import {getFormulationTypeByValue} from '../../constants';

function SubBrandSelect() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {prevRoute, input} = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );

  const {adminImages} = useSelector(
    (state: RootState) => state.addPictureAdvertisement,
  );

  const {state} = useLocation() as {state: IBrand};

  const subBrandToShow = state?.sub_brand?.filter(
    (item: ISubBrand) => item?.input?.guid === input?.guid,
  );

  const [inputValue, setInputValue] = useState('');

  const handleSelect = (item: ISubBrand) => {
    dispatch(
      addRegisterAdvertisement({
        sub_brand_data: item,
        title: item?.advertisement_title,
        description: item?.advertisement_description,
        combinations: item?.additional_data?.combinations ?? undefined,
        application_method:
          item?.additional_data?.application_method ?? undefined,
        quantity_pack: item?.additional_data?.weight ?? undefined,
        quantity_pack_unit: getQuantityPackUnitByValue(
          item?.additional_data?.weightUnit,
        ),
        price: item?.ad_price?.toString(),
        type: getFormulationTypeByValue(item?.additional_data?.formulation),
      }),
    );

    if (adminImages && adminImages.length) {
      dispatch(clearAdminImages());
    }

    item?.images?.forEach(img => {
      if (img.image) {
        dispatch(
          addingAdminImages({
            link: img.image,
            id: img.id,
            lastModified: Date.now(),
          }),
        );
      }
    });

    if (prevRoute?.includes('edit')) {
      navigate(prevRoute);
    } else {
      navigate('/advertisement-registeration');
    }
  };

  return (
    <div className="flex flex-col h-full px-3">
      <div className="flex h-[56px] w-full justify-between items-center text-md text-black">
        <div className="flex items-center">
          <i
            className="ml-3 text-xl font-bold icon-nameArrow---Right"
            onClick={() => navigate(-1)}
          />
          <span>نام محصول</span>
        </div>
        <i
          className="text-xl icon-nameClose-remove font-Bold"
          onClick={() => {
            navigate('/advertisement-registeration');
          }}
        />
      </div>
      <hr className="mx-2 mt-0 text-gray-300" />
      <div className="mt-2 ">
        <CustomSearchBox
          placeholder="جستجو"
          type="text"
          value={inputValue}
          inputCustomClass="!pr-4"
          preIcon="icon-nameSearch"
          onChange={e => setInputValue(e.target.value)}
          {...{inputValue, setInputValue}}
        />
      </div>

      <div className="flex flex-col flex-1 overflow-y-auto">
        {!state ? (
          <div className="flex items-center justify-center h-full">
            <DotsLoading />
          </div>
        ) : subBrandToShow.length === 0 ? (
          <div className="flex items-center justify-center min-h-full">
            <NoData />
          </div>
        ) : (
          subBrandToShow
            ?.filter(item => item.name.includes(inputValue))
            .map((item: ISubBrand) => (
              <span
                key={item.id}
                className="py-4 border-b"
                onClick={() => handleSelect(item)}
              >
                {item.name}
              </span>
            ))
        )}
      </div>
    </div>
  );
}

export default SubBrandSelect;
